import { Box, Typography, useMediaQuery } from "@mui/material"
import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react"
import { CardsList } from "./containers/Card"
import { ModalFaturamento } from "./containers/ModalFaturamento"
import { FATURAMENTO_TIPOS, FaturamentoType, IFaturamentoTipos, Projeto } from "src/components/projetos/types"
import { ModalSimulacaoFinanciamento } from "../../../containers/ModalSimulacaoFinanciamento"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import { CalcularType } from "../.."
import { setPersonalizadoTabDoneStatus, setServicoInformationModalStatus } from "src/store/vendas/projetos/actions"
import { HspProvider } from "src/providers/cadastros/HspProvider"
import { Layout } from "src/components/projetos/_layouts"
import { ResumoProjeto, ResumoProjetoRow } from "src/components/projetos/containers/ResumoProjeto"
import { OpcaoServicoSuspensa } from "src/components/projetos/containers/OpcaoServicoSuspensa"
import { NOVO_PROJETO_ENGENHARIA, POTENCIA_MINIMA_VERTICAL, PROPOSTA_OPTIONS } from "src/components/projetos/constants"
import theme from "src/theme/light"
import { InputsSection } from "src/components/projetos/containers/InputsSection"
import { Info } from "@mui/icons-material"
import { checarParametroRegiaoPotencia } from "src/components/projetos/utils/checarParametroRegiaoPotencia"
import { redirecionarParaEngenharia } from "src/components/projetos/utils/redirecionarParaEngenharia"
import { resetarProjeto } from "src/components/projetos/utils/resetarProjeto"
import { alterandoServico$, calculoProjetoRealizado$, exibeJustificativaValorServico$, formState$ } from "src/store/vendas/projetos/store"
import { useHistory } from "react-router-dom"
import { validacaoValorServicoMinimo } from "src/components/projetos/utils/validarValorServicoMinimo"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { ProjetosProvider } from "src/providers/ProjetosProvider"
import { verificaPendenciaTrocaComponente } from "src/components/projetos/utils/verificaPendenciaTrocaComponente"
import { showPendenciaTrocaComponenteAlert } from "src/components/projetos/utils/showPendenciaTrocaComponenteAlert"
import adminStore from "src/store/AdminStore"
import { mostrarAvisoServicoRemovido } from "src/components/projetos/utils/mostrarAvisoServicoRemovido"
import { notifierStore } from "src/framework/store/NotifierStore"
import { useObservable } from "src/framework/store/storeUtil"

interface FinalizacaoProps {
  onClickBack: () => void
  onClickNext: () => void
  formState: Projeto;
  onChangeFormState: Dispatch<SetStateAction<Projeto>>
  calcular: (data?: CalcularType) => Promise<any>
}

const projetosProvider = new ProjetosProvider()
const hspProvider = new HspProvider()
let timerCalcular: NodeJS.Timeout

const Finalizacao = ({ onClickBack, onClickNext, formState, onChangeFormState, calcular }: FinalizacaoProps) => {
  const history = useHistory();
  const permissoes = PermissionUtil.getPermissions();
  
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [valorMinimoServico, setValorMinimoServico] = useState(0)
  const [modalFaturamento, setModalFaturamento] = useState({ status: false, imgUrl: '', title: '' })
  const [modalSimulacaoFinanciamento, setModalSimulacaoFinanciamento] = useState(false)
  const [calculando, setCalculando] = useState(false)

  const calculoProjetoRealizado = useObservable(calculoProjetoRealizado$);
  const alterandoServico = useObservable(alterandoServico$);

  const [hspMedio, setHspMedio] = useState<number>(0)

  const setFormState = useCallback((newState: Partial<Projeto>) => {
    onChangeFormState(old => ({...old, ...newState}))
  },[onChangeFormState])

  useEffect(()=>{
    if ((formState.isEdit || formState.clonar_projeto) && Number(formState.valor_servico || 0) > 0 && !formState?.revenda?.segmentos_servico?.includes(formState?.segmento?.includes("on") ? "on" : "off")) {
      const state = { ...formState }

      state.valor_servico = 0;
      state.valor_servico_pis_cofins = 0;
      state.servico = null;
      state.codigo_servico = "";
      state.justificativa_valor_servico = null;
      state.tipo_proposta = PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null
      onChangeFormState(state);
      
      mostrarAvisoServicoRemovido()
    }
  },[])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = formState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[formState?.modulosList]);

  const potenciaVertical = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_VERTICAL
  },[potenciaTotal]);

  useEffect(()=>{
    if (potenciaTotal > 0) {
      projetosProvider.calcularValorMinimoServico(potenciaTotal || 0).then((response) => {
        setValorMinimoServico(response.data?.valor_minimo_servico || 0)
      })
    }
  },[potenciaTotal])

  useEffect(()=>{
    if (servicoObrigatorio && (formState?.valor_servico || 0) > 0 && valorMinimoServico > 0 && !validacaoValorServicoMinimo(formState?.valor_servico || 0, valorMinimoServico, permissoes)) {
      notifierStore.setNotifier({
        title: 'Atenção!',
        content: [
          'O valor do serviço não atende às exigências vigentes.',
          'Por favor, atualize conforme as instruções fornecidas abaixo do campo "Valor do Serviço Líquido”.'
        ],
        timeOut: 4000,
        onClose: () => notifierStore.setOpen(false),
      });
      notifierStore.setOpen(true);
    }
  },[valorMinimoServico, potenciaTotal])
  
  useEffect(() => {
    if (potenciaVertical && Number(formState?.valor_servico) > 0) {
      redirecionarParaEngenharia({
        onNegation: () => {
          formState$.next({
            ...resetarProjeto(formState), 
            ...NOVO_PROJETO_ENGENHARIA,
            servico: formState?.servico,
            valor_servico: formState?.valor_servico, 
            id: 0,
          })
          history.push('/projetos/verticais/novo',{ allowAccess: true })
        },
        onConfirmation: () => {
          const state = {...formState}
          state.servico = null;
          state.valor_servico = 0;
          state.tempo_garantia_servico = 0
          onChangeFormState(state)
        },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[potenciaVertical, history, formState?.valor_servico, onChangeFormState])

  useEffect(() => {
    if (formState.latitude && formState.longitude) {
      hspProvider.calcular(formState.latitude, formState.longitude).then((hsp)=>{
        setHspMedio(hsp?.hsp_medio || 0)
      })
    }
  },[formState.latitude, formState.longitude])

  useEffect(()=>{
    clearTimeout(timerCalcular)
    setCalculando(true)
    timerCalcular = setTimeout(()=>{
      calcular().finally(() => setCalculando(false))
    }, 300)
  }, [calcular])

  useEffect(()=>{
    for (const idx in FATURAMENTO_TIPOS){
      FATURAMENTO_TIPOS[idx].disable = false;

      /* Removido por solicitado da area de negocio
      if(FATURAMENTO_TIPOS[idx].id !== formState.tipo_faturamento){
        FATURAMENTO_TIPOS[idx].disable = formState.isEdit;
      }
      */
    }
  }, [formState.isEdit, null, undefined]);

  const resumoProjeto = useMemo((): ResumoProjetoRow[] =>{
    return [
      { label: 'Título', value: formState.titulo || '' },
      { label: 'HSP médio', value: hspMedio.toLocaleString() },
      { label: 'Potência do gerador (kWp)', value: `${(formState.resultado_calculos?.componentes?.potencia_gerador || 0).toLocaleString()} (kWp)` },
      { label: 'Peso do gerador (Kg)', value: `${(formState.resultado_calculos?.componentes?.peso_gerador || 0).toLocaleString()} (Kg)` },
      { label: 'Peso do gerador no telhado (Kg)', value: `${(formState.resultado_calculos?.componentes?.peso_telhado || 0).toLocaleString()} (Kg)` }
    ]
  }, [hspMedio, formState.titulo, formState.resultado_calculos])

  const valoresCalculos = useMemo((): { total: number; totalComponentes: number; totalServico: number } =>{
    const totalComponentes = Number(formState.resultado_calculos?.componentes?.valor || 0)
    const totalServico = Number(formState.resultado_calculos?.servicos?.valor_com_pis_cofins || 0)
    return { total: totalServico + totalComponentes, totalComponentes, totalServico }
  },[formState.resultado_calculos?.componentes?.valor, formState.resultado_calculos?.servicos?.valor_com_pis_cofins])
  
  const secaoValores = useMemo((): ResumoProjetoRow[] =>{
    return [
      { label: 'Valor dos produtos', value: Formater.toString(valoresCalculos.totalComponentes, TypeRecords.CURRENCY) },
      { label: (
        <Box display="flex" alignItems={isMobile ? "end" : "center"}>
          <Typography style={{ display: 'block', textAlign: 'start' }} variant='subtitle1'>Valor do serviço da revenda com PIS/COFINS</Typography>
          <Box onClick={() => setServicoInformationModalStatus(true)} component={'button'} style={{ background: 'none', cursor: 'pointer' }} border={"none"}>
            <Info color="primary" fontSize={"small"} />
          </Box>
        </Box>
      ),
        value: Formater.toString(valoresCalculos.totalServico, TypeRecords.CURRENCY),
        hide: Number(valoresCalculos.totalServico || 0) === 0,
      },
      { label: 'Valor total', value: <strong style={{ color: theme.palette.primary.main }}>{Formater.toString(valoresCalculos.total, TypeRecords.CURRENCY)}</strong> }
    ]
  },[valoresCalculos])

  const servicoObrigatorio = useMemo(()=>{
    if (potenciaVertical) return false;

    const moduloSelecionado = formState?.modulosList?.find(item => item.selecionado);
    if (!checarParametroRegiaoPotencia(moduloSelecionado)?.status) return false;

    return formState.tipo_faturamento === 'cliente' && formState.tipo_proposta?.value === 'gerador-com-instalacao'
  },[potenciaVertical, formState.tipo_faturamento, formState.tipo_proposta?.value, formState?.modulosList])

  const mostrarCampoValorServico = useMemo(()=>{
    return !!(servicoObrigatorio && formState.recebe_servico) 
  },[servicoObrigatorio, formState.recebe_servico])


  const exibirJustificativaValorServico = useMemo(() => {
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissoes)) return false;
    if (!mostrarCampoValorServico) return false;

    const valorServicoProjeto = Number(formState?.valor_servico || 0)

    if (valorServicoProjeto === 0) return false;
    if (Number(valorMinimoServico || 0) === 0) return false;

    return valorServicoProjeto < valorMinimoServico;
  },[formState?.valor_servico, mostrarCampoValorServico, permissoes, valorMinimoServico])

  useEffect(()=>{
    exibeJustificativaValorServico$.next(exibirJustificativaValorServico)
  },[exibirJustificativaValorServico])

  const handleNext = useCallback(async () => {
    if (formState?.isEdit) {
      const dataProjeto: Projeto | any = {...formState};
      if (formState?.id) {
        await adminStore.getProjetoTrocasPendentes(formState?.id).then((resp) => {
          if (resp && resp?.componentes) dataProjeto.componentes = resp?.componentes;
          if (resp && resp?.componentes_modificados) dataProjeto.componentes_modificados = resp?.componentes_modificados;
        });
      }
      if (verificaPendenciaTrocaComponente(dataProjeto)) {
        showPendenciaTrocaComponenteAlert();
        return;
      }
    }

    onClickNext()
  },[onClickNext, formState?.isEdit])

  useEffect(()=>{
    if (formState.recebe_servico === false || !formState.revenda) {
      const opt = PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null
      onChangeFormState({ ...formState, tipo_proposta: opt })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[formState.recebe_servico, formState.revenda])

  const [textoTooltipDisabled, setTextoTooltipDisabled] = useState<string>("Para salvar o projeto é necessário aceitar os termos do projeto.");
  const doneButtonIsDisabled = useMemo(()=>{
    if (!formState.tipo_proposta) {
      setTextoTooltipDisabled("Para salvar o projeto, é necessário preencher o tipo de proposta");
      return true;
    }
    if (servicoObrigatorio && !formState.valor_servico) {
      setTextoTooltipDisabled("Para salvar o projeto é necessário preencher o valor do serviço.");
      return true;
    }
    if (servicoObrigatorio && formState.valor_servico && Number(formState.valor_servico) === 0) {
      setTextoTooltipDisabled("Para salvar o projeto é necessário preencher o valor do serviço.");
      return true;
    }
    if (servicoObrigatorio && (formState?.valor_servico || 0) > 0 && !validacaoValorServicoMinimo(formState?.valor_servico || 0, valorMinimoServico, permissoes)) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário inserir o valor mínimo do serviço`);
      return true;
    }
    if (exibirJustificativaValorServico && !(formState?.justificativa_valor_servico || "")) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário inserir a justificativa do valor de serviço`);
      return true;
    }
    if (!calculoProjetoRealizado) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário realizar o cálculo dos valores do projeto.`);
      return true;
    }
    if (alterandoServico || calculando) {
      setTextoTooltipDisabled(`Aguarde o calculo finalizar para prosseguir.`);
      return true;
    }

    return false
  },[exibirJustificativaValorServico, formState?.justificativa_valor_servico, valorMinimoServico, formState.tipo_proposta, formState.valor_servico, servicoObrigatorio, permissoes, calculoProjetoRealizado, alterandoServico, calculando])

  useEffect(()=>{
    setPersonalizadoTabDoneStatus('finalizacao', !doneButtonIsDisabled)
  },[doneButtonIsDisabled])

  return (
    <>
      <Layout
        formState={formState}
        nextButtonIsDisabled={doneButtonIsDisabled}
        nextButtonDisabledTooltip={textoTooltipDisabled}
        title="Faturamento"
        subtitle="Escolha o tipo de faturamento!"
        onClickBack={onClickBack}
        onClickNext={handleNext}
        nextButtonLabel='Finalizar projeto'
      >
        <Box p={2}>
            <CardsList
              selected={formState.tipo_faturamento}
              onSelect={(tipo) => {
                const state = {...formState}
                const valor = tipo as FaturamentoType
                state.tipo_faturamento = valor

                const _faturamentoTipo = FATURAMENTO_TIPOS.find((f: IFaturamentoTipos) => f.id === valor);

                if(!_faturamentoTipo?.disable){
                  if (valor !== 'cliente') {
                    const tipoProposta = PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao')
                    state.tipo_proposta = tipoProposta || null
                  }

                  if (Number(state.valor_servico || 0) !== 0) {
                    state.valor_servico = 0;
                    state.tempo_garantia_servico = 0
                    calcular({ valorServico: 0 });
                  }
                  
                  onChangeFormState(state)
               }
              }}
              handleClickOnMoreInformations={id => setModalFaturamento({status: true, imgUrl: FATURAMENTO_TIPOS.find(item => item.id === id)?.modal.imgUrl || '', title: FATURAMENTO_TIPOS.find(item => item.id === id)?.modal.title || '' })}
              items={FATURAMENTO_TIPOS.map(({ id, title, subtitle, disable }) => ({ id, title, subtitle, disable }))}
            />

            <Box marginBottom={2}>
              <InputsSection
                mostrarCampoValorServico={mostrarCampoValorServico}
                servicoObrigatorio={servicoObrigatorio}
                formState={formState}
                setFormState={setFormState}
                valorMinimoServico={(formState.valor_servico || 0) > 0 ? valorMinimoServico > 0 && validacaoValorServicoMinimo((formState.valor_servico || 0), valorMinimoServico, permissoes) ? 0 : valorMinimoServico : 0}
                exibirJustificativaValorServico={exibirJustificativaValorServico}
              />
            </Box>

              {!formState?.recebe_servico && (
                <Box marginBottom={2}>
                  <OpcaoServicoSuspensa />
                </Box>
              )}

            
            <Box marginBottom={2}>
              <ResumoProjeto
                formState={formState}
                valores={secaoValores}
                resumoProjeto={resumoProjeto}
                simularFuncionamentoClick={() => setModalSimulacaoFinanciamento(true)}
              />
            </Box>

        </Box>
      </Layout>
      
      {modalFaturamento.status && <ModalFaturamento
        title={modalFaturamento.title}
        imgUrl={modalFaturamento.imgUrl}
        open={modalFaturamento.status}
        onClose={()=> setModalFaturamento({ status: false, imgUrl: '', title: '' })}
      />}

      {modalSimulacaoFinanciamento && (
        <ModalSimulacaoFinanciamento
          onChangeFormState={(newState:Partial<Projeto>) => {
            onChangeFormState({...formState, ...newState })
          }}
          open={modalSimulacaoFinanciamento}
          onClose={()=> setModalSimulacaoFinanciamento(false)}
          formState={formState}
          valorTotal={valoresCalculos.total}
        />
      )}
    </>
  )
}

export { Finalizacao }